/* eslint-disable import/no-duplicates */
import EN from 'assets/svgs/languages/en.svg';
import DE from 'assets/svgs/languages/de.svg';
import FR from 'assets/svgs/languages/fr.svg';
import IT from 'assets/svgs/languages/it.svg';
import ES from 'assets/svgs/languages/es.svg';
import PT from 'assets/svgs/languages/pt.svg';
import JA from 'assets/svgs/languages/ja.svg';
import CN from 'assets/svgs/languages/cn.svg';
import RU from 'assets/svgs/languages/ru.svg';
import AR from 'assets/svgs/languages/ar.svg';

import all from 'assets/svgs/status/all.svg';
import deactivated, {ReactComponent as DeactivatedIcon} from 'assets/svgs/status/deactived.svg';
import draft, {ReactComponent as DraftIcon} from 'assets/svgs/status/draft.svg';
import finished, {ReactComponent as FinishedIcon} from 'assets/svgs/status/finished.svg';
import mine from 'assets/svgs/status/mine.svg';
import published, {ReactComponent as PublishedIcon} from 'assets/svgs/status/published.svg';
import scheduled, {ReactComponent as ScheduledIcon} from 'assets/svgs/status/scheduled.svg';
import trash, {ReactComponent as TrashIcon} from 'assets/svgs/status/trash.svg';
import messages from './utils/messages';

export const Menus = Object.freeze({
  Statistics: messages.statistics,
  People: messages.people,
  Team: messages.team,
  Role: messages.role,
  Images: messages.images,
  Icons: messages.icons,
  documents: messages.documents,
});

export const CompanyTabs = Object.freeze({
  Profile: messages.profile,
  About: messages.about,
  Partner: messages.partner,
  Cloud: messages.cloud,
  Contract: messages.contract,
});

export const PartnerTabs = Object.freeze({
  // Partner: messages.partner,
  // List: messages.list,
  // Competition: messages.competition,
  // Award: messages.award,
  Report: messages.report,
  People: messages.people,
});

export const ReaderTabs = Object.freeze({
  // Statistics: messages.statics,
  // List: messages.list,
  Report: messages.report,
  People: messages.people,
});
export const SellerTabs = Object.freeze({
  People: messages.people,
});

export const JudgeTabs = Object.freeze({
  Report: messages.report,
  People: messages.people,
  Time: messages.time,
  Award: messages.award,
  Candidate: messages.candidate,
});

export const Languages = Object.freeze({
  EN: {code: 'EN', name: 'English', icon: EN},
  DE: {code: 'DE', name: 'German', icon: DE},
  FE: {code: 'FR', name: 'French', icon: FR},
  IT: {code: 'IT', name: 'Italian', icon: IT},
  ES: {code: 'ES', name: 'Spanish', icon: ES},
  PT: {code: 'PT', name: 'Portuguese', icon: PT},
  JA: {code: 'JA', name: 'Japanese', icon: JA},
  CN: {code: 'CN', name: 'Chinese', icon: CN},
  RU: {code: 'RU', name: 'Russian', icon: RU},
  AR: {code: 'AR', name: 'Arabic', icon: AR},
});

export const PageTypes = Object.freeze({
  Project: 'PROJECT',
  Product: 'PRODUCT',
  Information: 'INFORMATION',
  Company: 'COMPANY',
});

export const CategoryTypes = Object.freeze({
  Categories: 'CATEGORIES',
  Function: 'FUNCTION',
  Year: 'YEAR',
  Location: 'LOCATION',
  Group: 'GROUP',
  Since: 'SINCE',
  Country: 'LOCATION',
  Style: 'STYLE',
  Material: 'MATERIAL',
  Colour: 'COLOUR',
  Language: 'LANGUAGE',
  Designer: 'DESIGNER',
  Publication: 'PUBLICATION',
  Publisher: 'PUBLISHER',
  Type: 'Type',
  People: 'PEOPLE',
  Author: 'Author',
  Images: 'Images',
  Competition: 'COMPETITION',
});

export const getLabelArray = (value) =>
  Object.values(value).map((val) => ({
    label: val,
  }));
// abandon, use HistoryActions replace.
// export const Historys = Object.freeze(
//     {
//         created: 'Create post',
//         draft: 'Changed status (draft)',
//         trash: 'Changed status (trash)',
//         finished: 'Changed status (finished)',
//         scheduled: 'Changed status (scheduled)',
//         published: 'Changed status (publish)',
//         deActive: 'Changed status (deActive)',
//         image: 'Changed Feature Image',
//         title: 'Change title to %',
//         slug: 'Change slug to %',
//         company: 'Bind main company to %',
//         companies: 'Link companies to %',
//         featuredimage: 'Upload a featured image',
//     },
// );

export const HistoryActions = Object.freeze({
  // 英文版本的输出，后面的值可以后续随时调整
  // common
  create: 'Create post',
  draft: 'Changed status (draft)',
  finish: 'Changed status (finished)',
  schedule: 'Changed status (scheduled) @%',
  publish: 'Changed status (publish)',

  deactivate: 'Changed status (deactivate)',
  activate: 'Changed status (activate)',

  move: 'Move to %', // extra fields: post move > pageFolderId,
  trash: 'Changed status (trash)',
  delete: 'Move into trash', // move into trash
  recover: 'Recover from trash', // move out from trash
  // update : 'update', // Other update actions
  // EOF common

  // Post Update actions
  title: 'Change title to %',
  slug: 'Change slug to %',
  company: 'Bind main company to %',
  companies: 'Link % companies',

  featuredImage: 'Changed Feature Image', // update feature image by editor
  validity: 'Setup validity from %1, until %2', // partner can update post validity date. validityFromDate, validityUntilDate
  // EOF Post

  // CLOUD
  upload: 'upload %1 folders, %2 images', // Extra fields: Folders count and files count
  connect: 'Send to jidipi %', // send to jidipi, Extra field: page folder id,
  // EOF CLOUD
});
export const HistoryActionKeys = Object.keys(HistoryActions);
export const PartnerStatus = Object.freeze({
  ProfilePublished: {
    status: 'profilePublished',
    label: 'Profile Published',
    color: '#98A0AA',
    isStatus: true,
    className: 'text-capitalize hover3-class',
    icon: trash,
    svg: TrashIcon,
  },
  ProfileUnpublished: {
    status: 'profileUnpublished',
    label: 'Profile Unpublished',
    color: '#98A0AA',
    isStatus: true,
    className: 'text-capitalize hover3-class',
    icon: trash,
    svg: TrashIcon,
  },
  AboutPublished: {
    status: 'aboutPublished',
    label: 'About Published',
    color: '#98A0AA',
    isStatus: true,
    className: 'text-capitalize hover3-class',
    icon: trash,
    svg: TrashIcon,
  },
  AboutUnpublished: {
    status: 'aboutUnpublished',
    label: 'About Unpublished',
    color: '#98A0AA',
    isStatus: true,
    className: 'text-capitalize hover3-class',
    icon: trash,
    svg: TrashIcon,
  },
  BothPublished: {
    status: 'bothPublished',
    label: 'Both Published',
    color: '#98A0AA',
    isStatus: true,
    className: 'text-capitalize hover3-class',
    icon: trash,
    svg: TrashIcon,
  },
  BothUnpublished: {
    status: 'bothUnpublished',
    label: 'Both Unpublished',
    color: '#98A0AA',
    isStatus: true,
    className: 'text-capitalize hover3-class',
    icon: trash,
    svg: TrashIcon,
  },
});
export const PostStatus = Object.freeze({
  Trash: {
    status: messages.trash,
    color: '#9BA0AA99',
    isStatus: true,
    className: 'text-capitalize hover3-class',
    icon: trash,
    svg: TrashIcon,
  },
  DeActivated: {
    status: messages.deactivated,
    color: '#787AFF99',
    isStatus: true,
    className: 'text-capitalize  hover8-class',
    icon: deactivated,
    svg: DeactivatedIcon,
  },
  All: {
    status: 'All',
    color: '#F1F1F1',
    isStatus: false,
    className: 'text-capitalize hover2-class',
    icon: all,
  },
  Draft: {
    status: messages.draft,
    color: '#2094FA99',
    isStatus: true,
    className: 'text-capitalize  hover4-class',
    icon: draft,
    svg: DraftIcon,
  },
  Finished: {
    status: messages.finished,
    color: '#FF3B3080',
    isStatus: true,
    className: 'text-capitalize  hover5-class',
    icon: finished,
    svg: FinishedIcon,
  },
  Scheduled: {
    status: messages.scheduled,
    color: '#FF950099',
    isStatus: true,
    className: 'text-capitalize  hover6-class',
    icon: scheduled,
    svg: ScheduledIcon,
  },
  Published: {
    status: messages.published,
    color: '#04DE7199',
    isStatus: true,
    className: 'text-capitalize hover7-class',
    icon: published,
    svg: PublishedIcon,
  },
  Mine: {
    status: 'Mine',
    color: '#E3E3E3',
    isStatus: false,
    className: 'text-capitalize hover1-class',
    icon: mine,
  },
  UnSaved: {
    status: messages.unSaved,
    color: '#E3E3E3',
    isStatus: false,
    className: 'text-capitalize hover1-class',
    icon: mine,
  },
});
export const Voices = Object.freeze({
  draft: 'https://upload.jidipi.com/dashboard/jidipi-post-draft-save.mp3',
  trash: 'https://upload.jidipi.com/dashboard/jidipi-post-delete-to-trash.mp3',
  finished: 'https://upload.jidipi.com/dashboard/jidipi-post-finished.mp3',
  published: 'https://upload.jidipi.com/dashboard/jidipi-post-published.mp3',
  delete:
    'https://upload.jidipi.com/dashboard/jidipi-system-detele-permanent.mp3',
  import:
    'https://upload.jidipi.com/dashboard/jidipi-system-import-successful.mp3',
  move: 'https://upload.jidipi.com/dashboard/jidipi-system-move-folder.mp3',
  switchPage:
    'https://upload.jidipi.com/dashboard/jidipi-system-switch-page.mp3',
  switchTab: 'https://upload.jidipi.com/dashboard/jidipi-system-switch-tab.mp3',
});
export const GroupColor = Object.freeze({
  Architect: '#FF9C97',
  Decorator: '#AEAFFF',
  Designer: '#79BFFC',
  Manufacturer: '#68EBA9',
  Photographer: '#FFBF66',
  Retailer: '#FC7095',
  Agency: '#5AC8FA',
  Planner: '#9BA0AA',
  Engineer: '#FF3B30',
  Constractor: '#00F5EA',
  Supplier: '#FFF079',
  Contractor: '#66F9F2',
  Service: '#C3C6CC',
});

export const CategoryPerPage = Object.freeze({
  architectures: {
    level: 2,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Style,
      CategoryTypes.Year,
      CategoryTypes.Location,
    ],
    numbers: {
      categories: '01',
      function: '02',
      year: '81',
      location: '82',
    },
  },
  interiors: {
    level: 2,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Style,
      CategoryTypes.Year,
      CategoryTypes.Location,
    ],
    numbers: {
      categories: '01',
      style: '03',
      year: '81',
      location: '82',
    },
  },
  construction: {
    level: 3,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Function,
      CategoryTypes.Material,
      CategoryTypes.Designer,
    ],
    numbers: {
      categories: '04',
      function: '05',
      material: '83',
      designer: '61',
    },
  },
  electronics: {
    level: 3,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Function,
      CategoryTypes.Colour,
      CategoryTypes.Designer,
    ],

    numbers: {
      categories: '06',
      function: '07',
      colour: '84',
      designer: '61',
    },
  },
  furniture: {
    level: 3,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Material,
      CategoryTypes.Colour,
      CategoryTypes.Designer,
    ],
    numbers: {
      categories: '08',
      material: '83',
      colour: '84',
      designer: '61',
    },
  },
  goods: {
    level: 3,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Material,
      CategoryTypes.Colour,
      CategoryTypes.Designer,
    ],

    numbers: {
      categories: '09',
      material: '83',
      colour: '84',
      designer: '61',
    },
  },
  catalogues: {
    level: 2,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Language,
      CategoryTypes.Year,
      CategoryTypes.Type,
    ],
    numbers: {
      categories: '21',
      language: '85',
      year: '81',
      type: '22',
    },
  },
  videos: {
    level: 1,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Language,
      CategoryTypes.Year,
      CategoryTypes.People,
    ],
    numbers: {
      categories: '23',
      language: '85',
      year: '81',
      people: '62',
    },
  },
  presses: {
    level: 2,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Language,
      CategoryTypes.Year,
      CategoryTypes.Publication,
    ],
    numbers: {
      categories: '21',
      language: '85',
      year: '81',
      publication: '24',
    },
  },
  books: {
    level: 2,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Language,
      CategoryTypes.Year,
      CategoryTypes.Publisher,
      CategoryTypes.Author,
    ],
    numbers: {
      categories: '27',
      language: '85',
      year: '81',
      publisher: '28',
      author: '63',
    },
  },
  events: {
    level: 2,
    list: [CategoryTypes.Categories, CategoryTypes.Location],
    numbers: {
      categories: '29',
      location: '82',
    },
  },
  news: {
    level: 2,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Language,
      CategoryTypes.Year,
      CategoryTypes.Type,
    ],
    numbers: {
      categories: '25',
      language: '85',
      year: '81',
      type: '26',
    },
  },
  PARTNER: {
    level: 1,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Since,
      CategoryTypes.Group,
      CategoryTypes.Function,
    ],
  },
  LOCATION: {
    level: 2,
    list: [
      CategoryTypes.Categories,
      CategoryTypes.Function,
      CategoryTypes.Type,
      CategoryTypes.Country,
    ],
  },
});

export const Action = Object.freeze({
  publish: 'publish',
  single: 'edit',
  list: 'list',
});
export const ContentTypes = Object.freeze({
  project: 'project',
  product: 'product',
  profile: 'profile',
  about: 'about',
  partner: 'partner',
  info: 'info',
  category: 'category',
});

export function generatePermission(action, type) {
  return {action, type};
}

export const Permissions = [
  {action: 'list', hooks: [], name: '', type: 'project', id: 1},
  {
    action: 'list',
    hooks: [],
    name: '',
    type: 'product',
    id: 2,
  },
  {action: 'list', hooks: [], name: '', type: 'profile', id: 3},
  {
    action: 'list',
    hooks: [],
    name: '',
    type: 'about',
    id: 4,
  },
  {action: 'list', hooks: [], name: '', type: 'partner', id: 5},
  {
    action: 'list',
    hooks: [],
    name: '',
    type: 'info',
    id: 6,
  },
  {action: 'list', hooks: [], name: '', type: 'category', id: 7},
  {
    action: 'single',
    hooks: [],
    name: '',
    type: 'project',
    id: 8,
  },
  {action: 'single', hooks: [], name: '', type: 'product', id: 9},
  {
    action: 'single',
    hooks: [],
    name: '',
    type: 'profile',
    id: 10,
  },
  {action: 'single', hooks: [], name: '', type: 'about', id: 11},
  {
    action: 'single',
    hooks: [],
    name: '',
    type: 'partner',
    id: 12,
  },
  {action: 'single', hooks: [], name: '', type: 'info', id: 13},
  {
    action: 'single',
    hooks: [],
    name: '',
    type: 'category',
    id: 14,
  },
  {action: 'publish', hooks: [], name: '', type: 'project', id: 15},
  {
    action: 'publish',
    hooks: [],
    name: '',
    type: 'product',
    id: 16,
  },
  {action: 'publish', hooks: [], name: '', type: 'profile', id: 17},
  {
    action: 'publish',
    hooks: [],
    name: '',
    type: 'about',
    id: 18,
  },
  {action: 'publish', hooks: [], name: '', type: 'partner', id: 19},
  {
    action: 'publish',
    hooks: [],
    name: '',
    type: 'info',
    id: 20,
  },
  {action: 'publish', hooks: [], name: '', type: 'category', id: 21},
];

export const MainCategories = [
  {
    id: 1,
    name: 'architectures',
    symbol: 'A',
  },
  {
    id: 2,
    name: 'interiors',
    symbol: 'I',
  },
  {
    id: 3,
    name: 'constructions',
    symbol: 'C',
  },
  {
    id: 4,
    name: 'electronics',
    symbol: 'E',
  },
  {
    id: 5,
    name: 'furniture',
    symbol: 'F',
  },
  {
    id: 6,
    name: 'goods',
    symbol: 'G',
  },
];
